import { IThreshold } from '@interfaces/alarms/threshold';

import { MAX_PERCENT } from '@components/routes/AdminPanel/KpiThresholdManagement/constants';

export function validateThresholdsValues(thresholds: IThreshold[]) {
	const isPass = thresholds.every((threshold) => {
		if (threshold.minThreshold === null) return (threshold.maxThreshold || 0) <= MAX_PERCENT;
		if (threshold.maxThreshold === null) return (threshold.minThreshold || 0) <= MAX_PERCENT;

		return (threshold.minThreshold <= MAX_PERCENT) && (threshold.maxThreshold <= MAX_PERCENT)
			&& (threshold.minThreshold < threshold.maxThreshold);
	});

	return isPass;
}
